import React, { FC } from 'react';
import styled from 'styled-components';
import AgeCategorySelector from '../common/AgeCategorySelector';
import LoanFormatDropDown from './LoanFormatDropDown';
import { LinkContainer } from './NavigationLinksContainer';
import TitleDropdown from './TitleDropdown';
import SubNavigationLayout from './SubNavigationLayout';
import { NavigationLink } from './NavigationLink';
import { useTranslation } from 'react-i18next';
import ShopLanguageDropDown from './ShopLanguageDropDown';
import { useLoanFormat } from '../../app-store/loanFormat/useLoanFormat';

const StDropDownContainer = styled.div`
    display: flex;
    justify-content: flex-start;
`;

const StAgeCategorySelector = styled(AgeCategorySelector)`
    margin-left: 10px;
`;

type Props = {
    readonly isSticky: boolean;
    readonly shopLanguage?: string;
};

const UnlimitedNavigation: FC<Props> = ({ isSticky, shopLanguage }) => {
    const { t } = useTranslation();
    const { loanFormat } = useLoanFormat();

    const loanFormatKey = loanFormat?.key ?? 'all';
    const lowerLoanFormat = loanFormatKey.toLowerCase();

    return (
        <SubNavigationLayout
            left={
                <>
                    {shopLanguage ? <ShopLanguageDropDown currentShopLanguage={shopLanguage} /> : null}
                    <TitleDropdown isCampaigns loanFormat={undefined} shopLanguage={shopLanguage} />
                </>
            }
            center={
                <LinkContainer>
                    <li>
                        <NavigationLink to={`campaigns/${lowerLoanFormat}`}>
                            {t('menu.shop.unlimited.campaigns')}
                        </NavigationLink>
                    </li>
                </LinkContainer>
            }
            right={
                !isSticky && (
                    <StDropDownContainer>
                        <LoanFormatDropDown showIcons={false} />
                        <StAgeCategorySelector />
                    </StDropDownContainer>
                )
            }
            isSticky={isSticky}
            width="50"
        />
    );
};

export default UnlimitedNavigation;
